import React, { Component } from 'react';
import { reduxForm } from 'utils/reduxFormWrapper';
import HForm, { TextField } from 'shared/containers/portal_layout/HForm';
import actions from './actions';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

class ChangePassword extends Component {
  constructor(props, context) {
    super(props, context);
    this.changePassword = this.changePassword.bind(this);
  }

  changePassword(formValues) {
    return actions.changePassword(formValues).then(response => {
      FlashMessageActions.flashSuccess({ message: 'Your password has been changed' });
    });
  }

  render() {
    return <FormifiedPresentationComponent form="changePassword" onSubmit={this.changePassword} />;
  }
}

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <Errors errors={props.error || []} />
    <TextField type="password" name="currentPassword" label="Current Password" />
    <TextField type="password" name="password" label="New Password" />
    <TextField type="password" name="passwordConfirmation" label="Re-type New Password" />
    <div className="form-actions">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Change Password
      </SpinnerButton>
    </div>
  </HForm>
);

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default ChangePassword;
